import { Divider, Dropdown, Selector } from "antd-mobile";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { HomeCard } from "../../../../../components";
import { moneyFormat } from "../../../../../plugins/numberFormat";
import { useHandlingFee } from "../../context/HandlingFeeContext";
import styles from "./style.module.scss";
import "./style.scss";
const HandlingFeeData = () => {
  const { t } = useTranslation();
  const {
    months,
    selectedMonth,
    setSelectedMonth,
    levelBonusRate,
    agentFeeBonusData,
    isFeeDataError,
    isFeeDataLoading,
    totalBonus,
  } = useHandlingFee();
  const dropDownRef = useRef();

  const onSelectMonthChange = (value) => {
    if (value.length > 0) {
      const _month = months.find((month) => month.value === value[0]);
      setSelectedMonth(_month);
      dropDownRef.current.close();
    }
  };

  const comissionList = [
    {
      title: t("comission.calculation.winloss"),
      valueKey: "calculated_loss_amount",
      type: "content",
      symbol: "+",
    },
    {
      title: t("comission.calculation.platform"),
      valueKey: "total_game_3th_fee",
      type: "content",
      symbol: "-",
    },
    {
      title: t("comission.calculation.promotion"),
      valueKey: "total_promotion_rebate_fee",
      type: "content",
      symbol: "-",
    },
    {
      title: t("comission.calculation.comission"),
      valueKey: "basic_bonus_amount",
      type: "footer",
      symbol: "+",
    },
  ];

  return (
    <div className={`${styles.container} comission-container`}>
      <Dropdown ref={dropDownRef}>
        <Dropdown.Item key={"month"} className={"custom-dropdown"} title={selectedMonth?.label}>
          <div className={`handling-fee-filter-select`}>
            <Selector
              className={"custom-selector"}
              options={months}
              columns={2}
              value={selectedMonth?.value}
              onChange={onSelectMonthChange}
            />
          </div>
        </Dropdown.Item>
      </Dropdown>
      {isFeeDataLoading ? (
        ""
      ) : isFeeDataError ? (
        ""
      ) : (
        <>
          <HomeCard title={t("handlingFee.calculation.levelBonusTotal")}>
            {Object.keys(agentFeeBonusData?.data).map((key, index) => {
              const _level = key.split("-")[1];
              return (
                <>
                  <div className={`${styles.listRow}`}>
                    <div className={styles.title}>
                      {t("mobile.handlingFee.calculation.levelBonus", {
                        level: _level,
                      })}
                    </div>
                    <div className={styles.content}>
                      {`${moneyFormat(agentFeeBonusData?.data[key].level_bonus_amount)}`}
                    </div>
                  </div>
                  {index < Object.keys(agentFeeBonusData?.data).length - 1 ? (
                    <Divider className={styles.divider} />
                  ) : null}
                </>
              );
            })}
            <div className={`${styles.listRow} ${styles.footer}`}>
              <div className={styles.title}>{t("handlingFee.calculation.levelBonusTotal")}</div>
              <div className={styles.content}>{moneyFormat(totalBonus)}</div>
            </div>
          </HomeCard>
        </>
      )}
      <HomeCard title={t("mobile.handlingFee.ratio.title")}>
        {levelBonusRate
          ? levelBonusRate?.map((level, index) => {
              return (
                <>
                  <div className={`${styles.listRow}`}>
                    <div className={styles.title}>
                      {t("mobile.handlingFee.ratio.levelBonus", {
                        level: level.level,
                      })}
                    </div>
                    <div className={styles.content}>{`${level.bonus_rate || 0}%`}</div>
                  </div>
                  {index < levelBonusRate.length - 1 ? (
                    <Divider className={styles.divider} />
                  ) : null}
                </>
              );
            })
          : null}
      </HomeCard>
    </div>
  );
};

export default HandlingFeeData;
